import { type Repub, REPUBS } from '~/vendor/cx-modules/constants';

export function isValidRepub(repub: string): repub is Repub {
  return Boolean(REPUBS[repub as Repub]);
}
